<template>
    <div class="invoice-table">
        <el-table
            ref="invoiceTable"
            :data="datas"
            style="width: 100%"
            class="row-click ah-el-data-table"
            :row-class-name="getRowClass"
            @row-click="handleDataRowClick"
            :default-sort="sortSetting"
            empty-text="沒有資料"
            v-loading="loading"
            @sort-change="onSortChange"
            @select="onSelect"
            @select-all="onSelect"
            @selection-change="onSelectChange"
        >
            <el-table-column type="selection" width="42" key="checkbox"></el-table-column>
            <el-table-column prop="ioo" width="105">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot="header" slot-scope="scope">
                    <span @click="onTogglePjCustomNumber">
                        {{ showPjCustomNumber ? "自訂專案編號" : "單號" }}
                    </span>
                </template>
                <template slot-scope="scope">
                    <div class="idx">
                        {{ showPjCustomNumber ? getInvoicePjCustomNumber(scope.row) : scope.row.ioo }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="狀態" width="80" sortable="custom">
                <template slot-scope="scope">
                    <invoice-status-label :status-num="scope.row.status" />
                </template>
            </el-table-column>
            <el-table-column label="摘要 / 買受人（客戶）" min-width="200">
                <template slot-scope="scope">
                    <div>
                        <span class="type-tag">{{ getInvoiceType(scope.row.typ) }}</span>
                        <span class="strong">{{ scope.row.description }}</span>
                    </div>
                    <div style="color: #aaa; font-size: 9pt; line-height: 100%; margin-top: 6px">
                        {{ scope.row.vdR_NAM }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="statusQuery === 0 || statusQuery === 1" prop="foO_PDAT" label="預計開立日期" width="160" sortable="custom">
                <template slot-scope="scope">
                    <div class="idx">
                        <div>{{ scope.row.foO_PDAT | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="statusQuery === null || statusQuery === 2 || statusQuery === 3" prop="foO_DAT" label="發票號碼 / 發票日" width="160" sortable="custom">
                <template slot-scope="scope">
                    <div>
                        <div class="idx" v-if="scope.row.typ !== 4 && scope.row.foo">
                            <div style="font-size: 10pt">
                                <ahReceiptNumber :v="scope.row.foo" />
                            </div>
                            <div style="opacity: 0.5">
                                {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                            </div>
                        </div>
                        <div class="idx" v-if="scope.row.typ !== 4 && !scope.row.foo">
                            <!-- <div>未開立</div> -->
                            <div>(預計 {{ scope.row.foO_PDAT | dateFormater("YYYY-MM-dd") }} 開立)</div>
                        </div>
                        <div v-if="scope.row.typ === 4 && scope.row.tranInvoiceList.length" class="idx">
                            <el-tooltip placement="top" :manual="scope.row.tranInvoiceList.length === 1">
                                <div slot="content">
                                    <div v-for="(invoice, index) in getReimbursementInvoices(scope.row)" :key="index">{{ invoice.foo }}, {{ invoice.foO_DAT | dateFormater("YYYY-MM-dd") }}</div>
                                </div>
                                <div>
                                    <div style="font-size: 10pt">
                                        <ahReceiptNumber :v="getReimbursementInvoices(scope.row)[0].foo" />
                                        <span v-if="scope.row.tranInvoiceList.length > 1">（{{ scope.row.tranInvoiceList.length }}）</span>
                                    </div>
                                    <div style="opacity: 0.5; font-size: 12px;">{{ getReimbursementInvoices(scope.row)[0].foO_DAT | dateFormater("YYYY-MM-dd") }}</div>
                                </div>
                            </el-tooltip>
                        </div>
                        <div v-if="scope.row.typ === 4 && !scope.row.tranInvoiceList.length" class="idx">
                            <div style="font-size: 10pt">--</div>
                            <div style="opacity: 0.5">
                                {{ scope.row.foO_DAT | dateFormater("YYYY-MM-dd") }}
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="stF_NAM" label="申請人" width="100" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <div class="">{{ scope.row.stF_NAM }}</div>
                </template>
            </el-table-column>
            <el-table-column label="進度" class="progress" v-if="true" width="70">
                <template slot-scope="scope">
                    <ah-audit-progress :data="scope.row.audits" type="invoice" :statusCode="scope.row.status"></ah-audit-progress>
                </template>
            </el-table-column>
            <el-table-column prop="amt" label="含稅總計" align="right" width="110" sortable="custom">
                <template slot-scope="scope">
                    <Money :v="scope.row.amt" :precision="scope.row.cny === 'TWD' ? null : 4" />
                    <ahTip v-if="scope.row.cny != 'TWD'">
                        <div>
                            約當台幣：
                            <Money :v="scope.row.amt * scope.row.rat" round />
                        </div>
                        <div style="opacity: 0.8; font-size: 10pt; margin-top: 5px">匯率：{{ Math.round(scope.row.rat * 100) / 100 }}</div>
                    </ahTip>
                    <div class="amt-refund" v-if="scope.row.foO_DIS_CNL">發票作廢</div>
                    <div v-else-if="scope.row.foO_DIS_AMT" class="amt-refund">
                        <span v-if="scope.row.foO_DIS === 2">退回 </span>
                        <span v-if="scope.row.foO_DIS === 1">折讓 </span>
                        <Money :v="scope.row.foO_DIS_AMT" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="bnK_DAT" label="入帳日期" width="100" align="right" sortable="custom">
                <template slot-scope="scope">
                    <div>
                        <div class="idx" style="text-align: right; font-size: 10pt" v-if="scope.row.bnK_DAT">
                            {{ scope.row.bnK_DAT | dateFormater("YYYY-MM-dd") }}
                        </div>
                        <!-- <div class="idx" style="text-align: right; opacity: 0.5;">10</div> -->
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="invoiceTotalIncoming" label="入帳金額" align="right" width="110" sortable="custom">
                <template slot-scope="scope">
                    <Money :v="scope.row.invoiceTotalIncoming" :precision="scope.row.cny === 'TWD' ? null : 4" />
                    <div class="amt-refund" v-if="scope.row.invoiceTotalRefund">
                        <span>已退 </span>
                        <Money :v="scope.row.invoiceTotalRefund - getFutureRefund(scope.row.incomes)" />
                    </div>
                    <div class="amt-refund" v-if="getFutureRefund(scope.row.incomes)">
                        <span>待退 </span>
                        <Money :v="getFutureRefund(scope.row.incomes)" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="cny" label="幣別" width="60"></el-table-column>
        </el-table>
        <InvoiceDetailDialog ref="detailDialog" @close="handleDetailDialogClose" :visible="detailDialogVisible" :sno="detailDialogSno" />
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { invoiceType } from '@/assets/commonData/options';
import ahAuditProgress from '@/components/ui/ahAuditProgress.vue';
import ahReceiptNumber from '@/components/ui/ahReceiptNumber.vue';
import InvoiceStatusLabel from './InvoiceStatusLabel.vue';
import InvoiceDetailDialog from './InvoiceDetailDialog.vue';

export default {
    name: 'InvoiceTable',
    components: {
        InvoiceDetailDialog,
        InvoiceStatusLabel,
        ahAuditProgress,
        ahReceiptNumber,
    },
    props: {
        datas: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isSortByDate: {
            type: Boolean,
            default: true,
        },
        statusQuery: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            detailDialogVisible: false,
            detailDialogSno: null,
            lastDetailDialogSno: null,

            showPjCustomNumber: false,
        };
    },
    computed: {
        sortSetting() {
            if (this.isSortByDate) {
                return { prop: 'crT_DAT', order: 'descending' };
            }
            return { prop: null, order: null };
        },
    },
    methods: {
        // 判斷是否顯示固定匯率
        isCnyRatFixed(row) {
            return (row.paY_CNYRAT !== 1 && row.paY_CNYRAT !== 0) || row.status === 3;
        },
        // 按下表格一行
        handleDataRowClick(data) {
            this.detailDialogVisible = true;
            this.detailDialogSno = data.sno;
            this.lastDetailDialogSno = null;
            document.body.classList.add('detail-opened');
        },

        handleDetailDialogClose(refresh) {
            this.lastDetailDialogSno = this.detailDialogSno;
            this.detailDialogVisible = false;
            this.detailDialogSno = null;
            this.$emit('detailClose', refresh);
            document.body.classList.remove('detail-opened');
        },
        getRowClass({ row }) {
            if (row.sno === this.detailDialogSno) {
                return 'curr-detail-dialog-target';
            }
            if (row.sno === this.lastDetailDialogSno) {
                return 'last-detail-dialog-target';
            }
            return '';
        },
        getInvoiceType(type) {
            return invoiceType.find((x) => x.key === type)?.value;
        },

        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny == cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        showDetail(sno) {
            // 開啟詳細資料卡
            this.$refs.detailDialog.show(sno);
        },
        removeHighlight() {
            this.lastDetailDialogSno = null;
        },

        computedToBeCreditedAmount(row) {
            return row.toBeCreditedAmount + row.foO_DIS_AMT + row.invoiceTotalRefund;
        },

        getInvoicePjCustomNumber(row) {
            const PJ = row.projects;
            const LIST = _.chain(PJ)
                .map('customnumber')
                .filter((o) => o)
                .value();

            return LIST.length ? LIST.join(',') : '--';
        },
        onTogglePjCustomNumber() {
            this.showPjCustomNumber = !this.showPjCustomNumber;
        },
        getFutureRefund(incomes) {
            const sum = _.chain(incomes)
                .filter(['flg', -1])
                .filter((o) => moment(o.bnK_DAT).isAfter(moment()))
                .sumBy('amount')
                .value();

            return sum;
        },
        getReimbursementInvoices(row) {
            return _.map(row.tranInvoiceList, (o) => ({ foo: o.foo, foO_DAT: o.foO_DAT }));
        },
        onSortChange({ prop, order }) {
            console.log({ prop, order });
            this.$emit('sort-change', { prop, order });
        },
        clearSort() {
            this.$refs.invoiceTable.clearSort();
        },
        onSelect(selection, row) {
            this.$emit('select', selection, row);
        },
        onSelectChange(selection) {
            this.$emit('select-change', selection);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.invoice-table {
    .amt-refund {
        color: red;

        .label {
            display: inline-block;
            border: 1px solid red;
            border-radius: 5px;
            padding: 0px 10px;
            margin-right: 10px;
        }
    }
}
</style>
